import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MenuService } from 'src/app/components/menu/service/menu.service';
import {
  HomeActionColumn,
  HomeActionItem,
  HomeHeroSlide,
} from './models/home.models';
import { HomeService } from './service/home.service';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  slides: HomeHeroSlide[] = [];
  actionColumns: HomeActionColumn[] = [];

  constructor(
    private readonly homeService: HomeService,
    private readonly menuService: MenuService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    if (this.menuService.isMenuLoaded()) {
      this.loadMenuActions();
      this.loadDashboard();
      return;
    }

    this.subscription.add(
      this.menuService.whenMenuLoaded$().subscribe(() => {
        this.loadMenuActions();
        this.loadDashboard();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  navigateTo(item: HomeActionItem): void {
    this.router.navigateByUrl(`/${item.link}`);
  }

  openAcxPlatform(): void {
    this.menuService.openAcxPlatform();
  }

  get currentYear(): number {
    return new Date().getFullYear();
  }

  private loadMenuActions(): void {
    this.actionColumns = this.menuService.getHomeActionColumns();
  }

  private loadDashboard(): void {
    const options = {
      showCreditStock: this.menuService.hasCreditStockPermission(),
      showRegisteredProjects: this.menuService.hasProjectConsultPermission(),
    };
    const refresh = this.homeService.hasDashboardData();

    this.subscription.add(
      this.homeService.loadDashboard(options, refresh).subscribe(dashboard => {
        this.slides = dashboard.slides;
      }),
    );
  }
}
